import { render, staticRenderFns } from "./AssignmentDetails.vue?vue&type=template&id=6641dbc2&scoped=true&"
import script from "./AssignmentDetails.vue?vue&type=script&lang=js&"
export * from "./AssignmentDetails.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentDetails.vue?vue&type=style&index=0&id=6641dbc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6641dbc2",
  null
  
)

export default component.exports